export const CONTACT_PRICE_LABEL = "Giá liên hệ";
export const CUSTOM_COLOR_LABEL = "Nhiều màu tuỳ chọn";

export function getDisplayPrice(price) {
  const value = String(price || "").trim();
  return !value || value.toLowerCase().includes("liên hệ")
    ? CONTACT_PRICE_LABEL
    : value;
}

export function getDisplayColor() {
  return CUSTOM_COLOR_LABEL;
}
